import React from 'react';
import { cx } from '../../../../utils/cx';

export type VerifiedTickSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';

export interface VerifiedTickProps {
  size: VerifiedTickSize;
  className?: string;
}

export const VerifiedTick: React.FC<VerifiedTickProps> = ({ size, className }) => (
  <span className={cx('uui-verified-tick', `uui-verified-tick--${size}`, className)} aria-hidden="true">
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#9A9AA3" />
      <path
        d="M4.75 8.25L6.9 10.4L11.25 6.05"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);
